import { useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectQuestionProps } from '../../types';
import { SelectOption } from '../components/select-option';

const AUTO_ADVANCE_DELAY_MS = 0;

export const SelectQuestion = ({ question, onAutoAdvance }: SelectQuestionProps) => {
  const { control, clearErrors } = useFormContext();

  // Calculate options count including default options if none exist
  // HACK ALERT: every multiselect or select question must have at least 2 opts, this is to catch questions that have none

  const effectiveOptions =
    question.options && question.options.length > 0
      ? question.options
      : [
          { slug: 'yes', displayText: 'Yes' },
          { slug: 'no', displayText: 'No' },
        ];
  const optionsCount = effectiveOptions.length;
  const shouldUseGrid = optionsCount > 5;

  return (
    <Controller
      control={control}
      name={question.slug}
      render={({ field: { onChange, value } }) => {
        const handleChange = (newValue: string) => {
          // For select questions, if clicking the same value, deselect it
          const updatedValue = value === newValue ? '' : newValue;
          onChange(updatedValue);
          clearErrors(question.slug);

          // Auto-advance after selecting (not deselecting)
          if (updatedValue && onAutoAdvance) {
            setTimeout(() => {
              onAutoAdvance({ skipQuestion: false });
            }, AUTO_ADVANCE_DELAY_MS);
          }
        };

        return (
          <div className="questionnaire-question-content">
            <div className="select-question-container">
              <div className={`${shouldUseGrid ? 'select-options-grid' : 'select-options-list'}`}>
                {effectiveOptions.map((option) => {
                  return (
                    <SelectOption key={option.slug} option={option} value={value || ''} handleChange={handleChange} />
                  );
                })}
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};
